module.exports = __webpack_public_path__ + "assets/img/banner-bg.c354c4a8.webp";